<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import { useAuthStore } from './stores/auth'
import LoginView from './views/LoginView.vue'

const MainView = defineAsyncComponent(() => import('./views/MainView.vue'))

const authStore = useAuthStore()
const showMain = computed(() => authStore.isAuthenticated)
</script>

<template>
  <MainView v-if="showMain" />
  <LoginView v-else />
</template>
